/* @flow */
import PersistedComponent from './PersistedComponent'
import { type WidgetWithSectionsProps, type WidgetWithSectionsState } from './Types'

export default class WidgetWithSections extends PersistedComponent<WidgetWithSectionsProps, WidgetWithSectionsState> {
  constructor (props: WidgetWithSectionsProps) {
    super(props)

    const {
      widget: {
        meta: {
          sectionValues: configSections
        } = {}
      }
    } = props

    const boxesInSections = this.structureBoxesBySection()
    const sectionKeys = Object.keys(boxesInSections)
    const sections = Array.isArray(configSections) ? configSections.filter(section => {
      return sectionKeys.indexOf(section) > -1
    }) : sectionKeys

    this.persistedKeys = [ 'activeSection' ]

    this.state = Object.assign({}, this.state, {
      activeSection: sections[0],
      boxes: boxesInSections,
      sections
    })
  }

  setActive (activeSection: string): void {
    this.setState({
      activeSection
    })
  }

  handleSectionClick (section: string): void {
    this.setActive(section)
  }

  structureBoxesBySection (): {} {
    const {
      widget: {
        boxes,
        imageSize,
        meta: {
          sectionKeys: configSectionKeys,
          sectionValues: configSectionValues
        }
      }
    } = this.props

    const boxesInSections = {}

    boxes.forEach(box => {
      const section = (
        typeof configSectionKeys !== 'undefined' &&
        typeof configSectionValues !== 'undefined' &&
        configSectionKeys.indexOf(box.section) > -1
      ) ? configSectionValues[configSectionKeys.indexOf(box.section)]
        : box.section

      if (typeof boxesInSections[section] === 'undefined') {
        boxesInSections[section] = []
      }

      const boxWithImageInfo = Object.assign({}, box, {
        image: box.images[imageSize],
        imageClass: imageSize
      })

      boxesInSections[section].push(boxWithImageInfo)
    })

    return boxesInSections
  }
}
